import { Footer } from "antd/lib/layout/layout";
import dayjs from "dayjs";
import { ReactElement, useEffect, useState } from "react";
import s from "./AppFooter.module.scss";

const currentYear: number = new Date().getFullYear();

type BuildVersion = { commit: string; builtAt: string };

/**
 * `/version.json` lo scrive il rilascio della piattaforma accanto alla build e nginx
 * lo serve `no-store`: dice quale build è davvero in esercizio. In sviluppo non c'è
 * (404, o la SPA stessa in HTML), e allora la versione semplicemente non si mostra.
 */
async function fetchBuildVersion(): Promise<BuildVersion | null> {
  try {
    const response: Response = await fetch("/version.json", { cache: "no-store" });
    if (!response.ok) return null;
    const body = await response.json() as Partial<BuildVersion>;
    if (typeof body.commit !== "string" || typeof body.builtAt !== "string") return null;
    return { commit: body.commit, builtAt: body.builtAt };
  } catch {
    return null;
  }
}

export function AppFooter(): ReactElement {
  const [version, setVersion] = useState<BuildVersion | null>(null);

  useEffect(() => {
    let active: boolean = true;
    void fetchBuildVersion().then((v) => { if (active) setVersion(v); });
    return () => { active = false; };
  }, []);

  return (
    <Footer className={s.container}>
      <div></div>
      <div className={s.version}>
        <span>
          <span className={s.bold}>DriveBy</span>
          {version && ` Build ${version.commit} · ${dayjs(version.builtAt).format("DD/MM/YYYY HH:mm")}`}
        </span>
        <span>© 2024-{currentYear} Helioty S.r.l.</span>
      </div>
    </Footer>
  );
}
